import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';


function HighlightedText ({ text, textToHighlight, className, highlightClass }) {
    if (!textToHighlight) {
        return <span>{ text }</span>;
    }

    var regex = new RegExp(_.escapeRegExp(textToHighlight), 'i');
    var match = text.match(regex);

    if (!match) {
        return <span>{ text }</span>;
    }

    var index = match.index;
    var matchedText = match[0];

    return (
        <span className={ className }>
            { text.substring(0, index) }<span className={ highlightClass }>{ matchedText }</span>
            { text.substring(index + matchedText.length ) }
        </span>
    );
}


HighlightedText.propTypes = {
    text: PropTypes.string,
    textToHighlight: PropTypes.string,
    highlightClass: PropTypes.string,
    className: PropTypes.string
};

HighlightedText.defaultProps = {
    text: '',
    textToHighlight: null,
    highlightClass: null,
    className: null
};


export default HighlightedText;



// WEBPACK FOOTER //
// ./src/components/general/HighlightedText.js